import { render, staticRenderFns } from "./myorderdetail.vue?vue&type=template&id=5a6839a0&"
import script from "./myorderdetail.vue?vue&type=script&lang=js&"
export * from "./myorderdetail.vue?vue&type=script&lang=js&"
import style0 from "./myorderdetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports